import type { MessageChannel } from "@redotech/effect-api-shared/models/shopper-ai/conversation/message";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import type { ReactNode } from "react";
import { memo } from "react";
import {
  MessageChannelIcons,
  MessageChannelReadable,
} from "../ui/message-channel-ui";

export const ThreadHeader = memo(function ThreadHeader({
  channel,
  subject,
  trailing,
}: {
  channel: MessageChannel;
  subject?: string | null;
  /** Optional trailing content (e.g., "View recording" button for voice) */
  trailing?: ReactNode;
}) {
  const Icon = MessageChannelIcons[channel];
  const displaySubject = subject || MessageChannelReadable[channel];

  return (
    <Flex
      align="center"
      bgColor="tertiary"
      borderColor="primary"
      borderStyle="solid"
      borderWidth="1px"
      bottomLeftRadius="none"
      bottomRightRadius="none"
      gap="md"
      justify="space-between"
      p="xl"
      topLeftRadius="sm"
      topRightRadius="sm"
    >
      <Flex align="center" gap="md" minW="none">
        <Icon height={20} width={20} />
        <Text fontSize="sm" fontWeight="semibold" textColor="primary">
          {displaySubject}
        </Text>
      </Flex>
      {trailing && <Flex shrink={0}>{trailing}</Flex>}
    </Flex>
  );
});
